export default __webpack_public_path__ + "static/media/marauders-map-v5.0-02-00.0675481b.jpg";